<main class="mainhome">
  <div class="page-help-topics">
    <button pButton type="button" (click)="help.toggle($event)" class="icon-action" icon="fa fa-question-circle" pTooltip="View Help Topics" tooltipPosition="top"></button>
    <p-overlayPanel #help styleClass="page-help-interior">
      <h4 style="margin-bottom:5px;font-size:18px;">
        <i class="fa fa-question-circle"></i> Help Topics</h4>
      <ul>
        <li>
          <a (click)="displayA=true">Getting Started</a>
        </li>
        <li>
          <a (click)="displayB=true">Navigating OneLynk</a>
        </li>
        <li>
          <a (click)="displayC=true">Employees, Managers &amp; HCM</a>
        </li>
        <li>
          <a (click)="displayD=true">Time &amp; Expense</a>
        </li>
        <li>
          <a (click)="displayE=true">Bids &amp; Contracts</a>
        </li>
        <li>
          <a (click)="displayF=true">Estimates &amp; Projects</a>
        </li>
        <li>
          <a (click)="displayG=true">Procurement &amp; Orders</a>
        </li>
        <li>
          <a (click)="displayH=true">Finance &amp; Payroll</a>
        </li>
        <li>
          <a (click)="displayI=true">Analytics &amp; Reporting</a>
        </li>
        <li>
          <a (click)="displayJ=true">Settings &amp; Solutions</a>
        </li>
      </ul>
    </p-overlayPanel>
    <p-dialog header="Show Me | Overview: Getting Started" [(visible)]="displayA" [modal]="true" [responsive]="true">
      <iframe *ngIf="displayA" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Overview: Navigating OneLynk" [(visible)]="displayB" [modal]="true" [responsive]="true">
      <iframe *ngIf="displayB" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=149;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Overview: Employees, Managers and HCM" [(visible)]="displayC" [modal]="true" [responsive]="true">
      <iframe *ngIf="displayC" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=380;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Overview: Time &amp; Expense" [(visible)]="displayD" [modal]="true" [responsive]="true">
      <iframe *ngIf="displayD" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=544;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Overview: Bids &amp; Contracts" [(visible)]="displayE" [modal]="true" [responsive]="true">
      <iframe *ngIf="displayE" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=589;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Overview: Estimates &amp; Projects" [(visible)]="displayF" [modal]="true" [responsive]="true">
      <iframe *ngIf="displayF" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=635;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Overview: Procurement &amp; Orders" [(visible)]="displayG" [modal]="true" [responsive]="true">
      <iframe *ngIf="displayG" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=676;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Overview: Finance &amp; Payroll" [(visible)]="displayH" [modal]="true" [responsive]="true">
      <iframe *ngIf="displayH" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=749;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Overview: Analytics &amp; Reporting" [(visible)]="displayI" [modal]="true" [responsive]="true">
      <iframe *ngIf="displayI" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=810;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | Overview: Settings & Solutions" [(visible)]="displayJ" [modal]="true" [responsive]="true">
      <iframe *ngIf="displayJ" width="560" height="315" src="https://www.youtube.com/embed/W1ggRJCM3no?start=845;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </p-dialog>

  </div>
  <section class="home-grid">
    <ul class="p-grid">

      <li class="p-col-12 p-md-4 p-lg-4 top-apps">
        <!--<a (click)="qlikPunchOut(QlikAppName.Hub)">
          <i class="fa fa-signal"></i>
          <h3>My Dashboard</h3>
        </a>-->
        <a [routerLink]="RouteLink.MyDashBoard" routerLinkActive="active">
          <i class="fa fa-signal"></i>
          <h3>My Dashboard</h3>
        </a>

        <div id="dashboardApp"></div>
        <h5>Charts, maps, and graphs for your organization.</h5>
      </li>
      <li class="p-col-12 p-md-4 p-lg-4 top-apps">
        <div *ngIf="user.authenticated">
          <a [routerLink]="RouteLink.Worklist" routerLinkActive="active">
            <i class="fa fa-th-list"></i>
            <h3>Worklist
              <div class="worklist-main-badge">{{user.worklistSubmittedOrApproved}}</div>
            </h3>
          </a>
        </div>
        <h5>Your prioritized to-do list.</h5>
      </li>
      <!-- ACase: hid marketplace section for now until we have it
      <li class="p-col-12 p-md-6 p-lg-3 top-apps">
        <i class="fa fa-globe"></i>
        <h3>Marketplace</h3>-->

      <!-- <app-connect></app-connect>  -->
      <!-- <h5>Collaborate with other businesses.</h5>
      </li>   -->
      <li class="p-col-12 p-md-4 p-lg-4 top-apps">
        <a [routerLink]="RouteLink.CorpCalendar" routerLinkActive="active">
          <i class="fa fa-calendar"></i>
          <h3>Calendar</h3>
        </a>
        <h5>Access your organization calendar.</h5>
      </li>
      <div class="col-12"></div>

      <!-- Modules -->
      <li *ngIf="user.hasRole[Roles.ESS]" class="p-col-12 p-md-4 p-lg-2 ol-module">
        <button type="text" (click)="ess.toggle($event)" pTooltip="Manage your employee information &amp; make requests." tooltipPosition="top">
          <i class="fa fa-user icon-core"></i>
          <h3 class="grid-head">Employee
            <br>
            <span class="main-link-sub">Self-Service</span>
          </h3>
          <i class="fa fa-2x fa-caret-down"></i>
        </button>
        <p-overlayPanel #ess styleClass="menu-double">
          <h6>Employee Self-Service</h6>
          <ul class="main-connect p-grid" *ngIf="user.hasRole[Roles.ESS]">
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.Profile" routerLinkActive="active">My Profile</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.SelfAppraisal" routerLinkActive="active">Self-Appraisal</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.LeaveRequest" routerLinkActive="active">Leave Request</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.QualifyingLifeEvent" routerLinkActive="active">Qualifying Life Event</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.BenefitSelection" routerLinkActive="active">Benefit Selection</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.VacationRequest" routerLinkActive="active">Vacation Request</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.WorkAuthSummary" routerLinkActive="active">Work Authorization</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.TrainingRequest" routerLinkActive="active">Training Request</a>
            </li>
          </ul>
        </p-overlayPanel>
      </li>
      <li *ngIf="user.hasRole[Roles.MSS]" class="p-col-12 p-md-4 p-lg-2 ol-module">
        <button type="text" (click)="mss.toggle($event)" pTooltip="Manage information for your team." tooltipPosition="top">
          <i class="fa fa-globe icon-core"></i>
          <h3 class="grid-head">Manager
            <br>
            <span class="main-link-sub">Self-Service</span>
          </h3>
          <i class="fa fa-2x fa-caret-down"></i>
        </button>
        <p-overlayPanel #mss styleClass="menu-single">
          <h6>Manager Self-Service</h6>
          <ul class="main-connect p-grid" *ngIf="user.hasRole[Roles.MSS]">
            <li class="p-col-12">
              <a [routerLink]="RouteLink.EmployeeChangeRequest" routerLinkActive="active">Employee Changes</a>
            </li>
            <li class="p-col-12">
              <a [routerLink]="RouteLink.EmployeeLeaveHistory" routerLinkActive="active">Employee Leave History</a>
            </li>
            <li class="p-col-12">
              <a [routerLink]="RouteLink.RecruitToHire" routerLinkActive="active">Recruit-to-Hire</a>
            </li>
            <li class="p-col-12">
              <a [routerLink]="RouteLink.EmployeeAppraisal" routerLinkActive="active">Employee Appraisal</a>
            </li>
          </ul>
        </p-overlayPanel>
      </li>
      <li *ngIf="user.hasRole[Roles.HrGeneralist]" class="p-col-12 p-md-4 p-lg-2 ol-module">
        <button type="text" (click)="hcm.toggle($event)" pTooltip="Manage your organization's HCM information." tooltipPosition="top">
          <i class="fa fa-sitemap icon-core"></i>
          <h3 class="grid-head">Human Capital
            <br>
            <span class="main-link-sub">Management</span>
          </h3>
          <i class="fa fa-2x fa-caret-down"></i>
        </button>
        <p-overlayPanel #hcm styleClass="menu-double">
          <h6>Human Capital Management</h6>
          <ul class="main-connect p-grid" *ngIf="user.hasRole[Roles.HrGeneralist]">
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.ResourceManagement" routerLinkActive="active">Resource Management</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.AppraisalAdmin" routerLinkActive="active">Appraisal Setup</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.BenefitProvider" routerLinkActive="active">Benefits</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.EmployeeClass" routerLinkActive="active">Employee Class</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.JobPostingSite" routerLinkActive="active">Job Posting Site</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.OfferLetter" routerLinkActive="active">Offer Letters</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.OfferLetterClause" routerLinkActive="active">Offer Letter Clauses</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.Position" routerLinkActive="active">Positions</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.PositionGrade" routerLinkActive="active">Position Grade</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.PtoPolicy" routerLinkActive="active">PTO Policies</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.ScreeningQuestion" routerLinkActive="active">Screening Questions</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.ScreeningQuestionCategory" routerLinkActive="active">Screening Categories</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.RecruitToHire" routerLinkActive="active">Recruit-to-Hire</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.VirtualOrientation" routerLinkActive="active">Virtual Orientation</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.EmployeeOffboardingChecklist" routerLinkActive="active">Termination Checklist</a>
            </li>
            <li *ngIf="user.hasRole[Roles.HcmDashboard]" class="p-col-12 p-md-12 p-lg-6">
              <a (click)="qlikPunchOut(QlikAppName.Hcm)" routerLinkActive="active">People Dashboard</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="[RouteLink.WageDeterminationSummary]" routerLinkActive="active">Wage Determinations</a>
            </li>
          </ul>
        </p-overlayPanel>
      </li>
      <li *ngIf="user.hasRole[Roles.FinanceTimesheet] || user.hasRole[Roles.FinanceExpense] || user.hasRole[Roles.FinanceTimesheetAdmin]" class="p-col-12 p-md-4 p-lg-2 ol-module">
        <button type="text" (click)="timexp.toggle($event)" pTooltip="Manage timesheets &amp; expense reports." tooltipPosition="top">
          <i class="fa fa-clock-o icon-core"></i>
          <h3 class="grid-head">Time &amp; Expense</h3>
          <i class="fa fa-2x fa-caret-down"></i>
        </button>
        <p-overlayPanel #timexp styleClass="menu-single">
          <h6>Time &amp; Expense</h6>
          <ul *ngIf="user.hasRole[Roles.FinanceTimesheet] || user.hasRole[Roles.FinanceExpense] || user.hasRole[Roles.FinanceTimesheetAdmin]" class="main-connect p-grid">
            <li *ngIf="user.hasRole[Roles.FinanceTimesheet] " class="p-col-12">
              <a [routerLink]="RouteLink.Timesheet" routerLinkActive="active">My Timesheet</a>
            </li>
            <li *ngIf="user.hasRole[Roles.MSS] || user.hasRole[Roles.FinanceTimesheetApprover]" class="p-col-12">
              <a [routerLink]="RouteLink.TimesheetManager" routerLinkActive="active">Timesheet Approval</a>
            </li>
            <li *ngIf="user.hasRole[Roles.FinanceTimesheetAdmin]" class="p-col-12">
              <a [routerLink]="RouteLink.TimesheetAdmin" routerLinkActive="active">Timesheet Admin</a>
            </li>
            <li *ngIf="user.hasRole[Roles.FinanceExpense]" class="p-col-12">
              <a [routerLink]="RouteLink.ExpenseReport" routerLinkActive="active"> Expense Report</a>
            </li>
          </ul>
        </p-overlayPanel>
      </li>
      <li *ngIf="user.hasRole[Roles.Procurement] || user.hasRole[Roles.ItemCatalogAdmin] || user.hasRole[Roles.AP] || user.hasRole[Roles.ItemReceipt] || user.hasRole[Roles.ItemReturn] ||
      user.hasRole[Roles.MaterialOrder]"
          class="p-col-12 p-md-4 p-lg-2 ol-module">
        <button type="text" (click)="proc.toggle($event)" pTooltip="Manage vendors &amp; purchasing for your organization." tooltipPosition="top">
          <i class="fa fa-shopping-cart icon-fulfillment"></i>
          <h3 class="grid-head">Procurement</h3>
          <i class="fa fa-2x fa-caret-down"></i>
        </button>
        <p-overlayPanel #proc styleClass="menu-double">
          <h6>Procurement</h6>
          <ul class="main-connect p-grid">
            <li *ngIf="user.hasRole[Roles.Procurement]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.PurchaseRequisition" routerLinkActive="active">Purchase Requisition/PO</a>
            </li>
            <li *ngIf="user.hasRole[Roles.ItemReceipt]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.Receipt" routerLinkActive="active">Item Receipt</a>
            </li>
            <li *ngIf="user.hasRole[Roles.ItemCatalogAdmin]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.ItemCatalogAdmin" routerLinkActive="active">Item Catalog</a>
            </li>
            <li *ngIf="user.hasRole[Roles.ItemReturn]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.PurchaseReturn" routerLinkActive="active">Item Return</a>
            </li>
            <li *ngIf="user.hasRole[Roles.AP]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.Vendor" routerLinkActive="active">Vendors</a>
            </li>
            <li *ngIf="user.hasRole[Roles.MaterialOrder]" class="p-col-12 p-md-12 p-lg-6">
              <a routerLink="/procurement/material-order" routerLinkActive="active">Material Order </a>
            </li>
            <li *ngIf="user.hasRole[Roles.AP]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.VendorInvoice" routerLinkActive="active">Vendor Bills</a>
            </li>
            <li *ngIf="user.hasRole[Roles.ProcurementDashboard]" class="p-col-12 p-md-12 p-lg-6">
              <a (click)="qlikPunchOut(QlikAppName.Procurement)" routerLinkActive="active">Spend Analysis Dashboard</a>
            </li>
          </ul>
        </p-overlayPanel>
      </li>
      <li *ngIf="user.hasRole[Roles.SalesOrder] || user.hasRole[Roles.PackingSlip] || user.hasRole[Roles.SalesReturn] || user.hasRole[Roles.AR]" class="p-col-12 p-md-4 p-lg-2 ol-module">
        <button type="text" (click)="ordermgt.toggle($event)" pTooltip="Manage customers &amp; sales for your organization." tooltipPosition="top">
          <i class="fa fa-list-alt icon-fulfillment"></i>
          <h3 class="grid-head">Orders</h3>
          <i class="fa fa-2x fa-caret-down"></i>
        </button>
        <p-overlayPanel #ordermgt styleClass="menu-single" [style]="{'width':'215px','max-width':'215px'}">
          <h6>Orders</h6>
          <ul class="main-connect p-grid" style="width:200px;">
            <li *ngIf="user.hasRole[Roles.SalesOrder]" class="p-col-12">
              <a [routerLink]="RouteLink.SalesOrder" routerLinkActive="active">Sales Order</a>
            </li>
            <li *ngIf="user.hasRole[Roles.PackingSlip]" class="p-col-12">
              <a [routerLink]="RouteLink.PackingSlip" routerLinkActive="active">Packing Slip</a>
            </li>
            <li *ngIf="user.hasRole[Roles.SalesReturn]" class="p-col-12">
              <a [routerLink]="RouteLink.SalesReturn" routerLinkActive="active">Sales Return</a>
            </li>
            <li *ngIf="user.hasRole[Roles.AR]" class="p-col-12">
              <a [routerLink]="RouteLink.Customer" routerLinkActive="active">Customers</a>
            </li>
            <li *ngIf="user.hasRole[Roles.AR]" class="p-col-12">
              <a [routerLink]="RouteLink.CatalogCustomerInvoice" routerLinkActive="active">Catalog Invoice</a>
            </li>
            <li *ngIf="user.hasRole[Roles.AR]" class="p-col-12">
              <a [routerLink]="RouteLink.ManualContractProjectCustomerInvoice" routerLinkActive="active">Manual Contract/Project Invoice</a>
            </li>
            <li *ngIf="user.hasRole[Roles.AR]" class="p-col-12">
              <a [routerLink]="RouteLink.ContractProjectCustomerInvoice" routerLinkActive="active">Contract/Project Invoice</a>
            </li>
          </ul>
        </p-overlayPanel>
      </li>
      <li *ngIf="user.hasRole[Roles.AP] || user.hasRole[Roles.AR] || user.hasRole[Roles.ChargeCodeAdmin] || user.hasRole[Roles.ChartOfAccountAdmin] || user.hasRole[Roles.GeneralLedgerAdmin] ||
      user.hasRole[Roles.VoucherRegister] || user.hasRole[Roles.AccountantSME] " class="p-col-12 p-md-4 p-lg-2 ol-module">
        <button type="text" (click)="finance.toggle($event)" pTooltip="Manage your organization's financial information." tooltipPosition="top">
          <i class="fa fa-credit-card icon-accounts"></i>
          <h3 class="grid-head">Finance</h3>
          <i class="fa fa-2x fa-caret-down"></i>
        </button>
        <p-overlayPanel #finance styleClass="menu-double">
          <h6>Finance</h6>
          <ul class="main-connect p-grid">
            <li *ngIf="user.hasRole[Roles.AP]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.AccountPayable" routerLinkActive="active">Accounts Payable</a>
            </li>
            <li *ngIf="user.hasRole[Roles.ChargeCodeAdmin]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.AccountGroup" routerLinkActive="active">Account Groups</a>
            </li>
            <li *ngIf="user.hasRole[Roles.VoucherRegister]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.VoucherRegister" routerLinkActive="active">Voucher Register</a>
            </li>
            <li *ngIf="user.hasRole[Roles.ChartOfAccountAdmin] || user.hasRole[Roles.AccountantSME]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="[RouteLink.SolMgrChartOfAccountsSetup, RouteLink.ChartOfAccountSetupFinancePath, RouteLink.ChartOfAccountSetupCoa]" routerLinkActive="active">Chart of Accounts</a>
            </li>
            <li *ngIf="user.hasRole[Roles.AccountantSME]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.SolMgrModelOptionsSummary" routerLinkActive="active">COA Model</a>
            </li>
            <li *ngIf="user.hasRole[Roles.AR]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.AccountReceivable" routerLinkActive="active">Accounts Receivable</a>
            </li>
            <li *ngIf="user.hasRole[Roles.AR]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.RevenueRecognition" routerLinkActive="active">Revenue Recognition</a>
            </li>
            <li *ngIf="user.hasRole[Roles.GeneralLedgerAdmin]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.GeneralLedger" routerLinkActive="active">General Ledger</a>
            </li>
            <li *ngIf="user.hasRole[Roles.ChargeCodeAdmin]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.ChargeCodeAdmin" routerLinkActive="active">Charge Codes</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.FinanceCalendar" routerLinkActive="active">Finance Calendar</a>
            </li>
            <!-- ToDo need to add role check -->
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.FinancialReport" routerLinkActive="active">Financial Report</a>
            </li>
            <li *ngIf="user.hasRole[Roles.PaymentTermsAdmin]" class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.PaymentTermAdmin" routerLinkActive="active">Payment Terms Setup</a>
            </li>
            <li *ngIf="user.hasRole[Roles.FinanceDashboard]" class="p-col-12 p-md-12 p-lg-6">
              <a (click)="qlikPunchOut(QlikAppName.Finance)" routerLinkActive="active">Finance Dashboard</a>
            </li>
          </ul>
        </p-overlayPanel>
      </li>
      <li *ngIf="user.hasRole[Roles.PayrollAdmin]" class="p-col-12 p-md-4 p-lg-2 ol-module">
        <button type="text" [routerLink]="RouteLink.Payroll" routerLinkActive="active" pTooltip="Manage payroll for your organization." tooltipPosition="top">
          <i class="fa fa-usd icon-accounts"></i>
          <h3 class="grid-head">Payroll</h3>
        </button>
      </li>
      <li *ngIf="user.hasRole[Roles.Contract]" class="p-col-12 p-md-4 p-lg-2 ol-module">
        <button type="text" (click)="contract.toggle($event)" routerLinkActive="active" pTooltip="Manage bids &amp; contracts." tooltipPosition="top">
          <i class="fa fa-handshake-o icon-manage"></i>
          <h3 class="grid-head">Bids &amp; Contracts </h3>
          <i class="fa fa-2x fa-caret-down"></i>

        </button>
        <p-overlayPanel #contract styleClass="menu-single">
          <h6>Bids &amp; Contracts</h6>
          <ul class="main-connect p-grid">
            <li class="p-col-12">
              <a [routerLink]="[RouteLink.ContractBidLink, RouteLink.BidTab]" routerLinkActive="active">Bids</a>
            </li>
            <li class="p-col-12">
              <a [routerLink]="[RouteLink.ContractSummary, RouteLink.ContractTab]" routerLinkActive="active">Contracts</a>
            </li>
            <li class="p-col-12">
              <a [routerLink]="RouteLink.BillingPlanSummary" routerLinkActive="active"> Default Billing Plan</a>
            </li>
            <li class="p-col-12">
              <a [routerLink]="RouteLink.AtRiskRequest" routerLinkActive="active">At-Risk Request</a>
            </li>
            <li class="p-col-12">
              <a [routerLink]="RouteLink.ContractProjectPnL" routerLinkActive="active">Contract/Project P&L</a>
            </li>
          </ul>
        </p-overlayPanel>
      </li>

      <li *ngIf="user.hasRole[Roles.Project]" class="p-col-12 p-md-4 p-lg-2 ol-module">
        <button type="text" (click)="project.toggle($event)" pTooltip="Manage estimates &amp; projects." tooltipPosition="top">
          <i class="fa fa-tasks icon-manage"></i>
          <h3 class="grid-head">Estimates &amp; Projects </h3>
          <i class="fa fa-2x fa-caret-down"></i>
        </button>
        <p-overlayPanel #project [style]="{'left':'0'}" styleClass="menu-double">
          <h6>Estimates &amp; Projects</h6>
          <ul class="main-connect p-grid">
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="[RouteLink.ProjectEstimateLink, RouteLink.EstimateTab]" routerLinkActive="active">Estimates</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="[RouteLink.ProjectSummary, RouteLink.ProjectTab]" routerLinkActive="active">Projects</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.ProjectCatalog" routerLinkActive="active"> Project Catalog</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.BillingPlanSummary" routerLinkActive="active"> Default Billing Plan</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.AtRiskRequest" routerLinkActive="active">At-Risk Request</a>
            </li>
            <li *ngIf="user.hasRole[Roles.ProjectContractDashboard]" class="p-col-12 p-md-12 p-lg-6">
              <a (click)="qlikPunchOut(QlikAppName.Project)" routerLinkActive="active"> Project Dashboard</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.ContractProjectPnL" routerLinkActive="active">Contract/Project P&L</a>
            </li>
            <li class="p-col-12 p-md-12 p-lg-6">
              <a [routerLink]="RouteLink.ProjectStatusReport" routerLinkActive="active">Projects Status Reports</a>
            </li>
            <li>
          </ul>
        </p-overlayPanel>
      </li>


      <li *ngIf="user.hasRole[Roles.CyberplanCertifier] || user.hasRole[Roles.CyberplanAssessor] || user.hasRole[Roles.CyberplanRemediator]" class="p-col-12 p-md-4 p-lg-2 ol-module">
        <button type="text" (click)="cyberplanOP.toggle($event)" pTooltip="Security Assessments" tooltipPosition="top">
          <i class="fa fa-lock icon-manage"></i>
          <h3 class="grid-head">Security
            <br>
            <span class="main-link-sub">Assessments</span>
          </h3>
          <i class="fa fa-2x fa-caret-down"></i>
        </button>
        <p-overlayPanel #cyberplanOP styleClass="menu-single">
          <h6>Security Assessments</h6>
          <ul class="main-connect p-grid">
            <li class="p-col-12">
              <a [routerLink]="RouteLink.CyberplanSystemsSummary" routerLinkActive="active">System</a>
            </li>
            <li *ngIf="user.hasRole[Roles.CyberplanAssessor]" class="p-col-12">
              <a [routerLink]="RouteLink.CyberplanSecurityPolicy" routerLinkActive="active">Policy</a>
            </li>
            <li *ngIf="user.hasRole[Roles.CyberplanAssessor]" class="p-col-12">
              <a [routerLink]="RouteLink.CyberplanSecurityThreat" routerLinkActive="active">Threat</a>
            </li>
            <li *ngIf="user.hasRole[Roles.CyberplanAssessor]" class="p-col-12">
              <a [routerLink]="RouteLink.Customer" routerLinkActive="active">Customer</a>
            </li>
          </ul>
        </p-overlayPanel>
      </li>
      <li class="p-col-12 p-md-4 p-lg-2 ol-module">
        <button type="text" (click)="proc.toggle($event)" pTooltip="Business Analytics" tooltipPosition="top">
          <i class="fa fa-file icon-info"></i>
          <h3 class="grid-head">Business
            <br>
            <span class="main-link-sub">Analytics</span>
          </h3>
          <i class="fa fa-2x fa-caret-down"></i>
        </button>
        <p-overlayPanel #proc styleClass="menu-single">
          <h6>Business Analytics</h6>
          <ul class="main-connect p-grid">
            <li class="p-col-12">
              <a [routerLink]="RouteLink.Reporting" routerLinkActive="active">Reporting</a>
            </li>
            <li *ngIf="user.hasRole[Roles.ExecutiveDashboard]" class="p-col-12">
              <a (click)="qlikPunchOut(QlikAppName.Executive)" routerLinkActive="active">Executive Dashboards</a>
            </li>
          </ul>
        </p-overlayPanel>
      </li>
      <li *ngIf="user.hasRole[Roles.SupportFile]" class="p-col-12 p-md-4 p-lg-2 ol-module">
        <button type="text" (click)="sf.toggle($event)" pTooltip="Manage your support files." tooltipPosition="top">
          <i class="fa fa-files-o icon-info"></i>
          <h3 class="grid-head">Support Files
            <br>
          </h3>
          <i class="fa fa-2x fa-caret-down"></i>
        </button>

        <p-overlayPanel #sf styleClass="menu-single" [style]="{'width':'205px'}">
          <h6>Support Files</h6>
          <ul class="main-connect p-grid" *ngIf="user.hasRole[Roles.SupportFile]">
            <li class="p-col-12">
              <a [routerLink]="RouteLink.FileSharingOnboardingFiles" routerLinkActive="active">Customer Onboarding</a>
            </li>
            <li class="p-col-12" style="width:190px;">
              <a [routerLink]="RouteLink.FileSharingMaintenanceFiles" routerLinkActive="active">Supporting Docs</a>
            </li>
          </ul>
        </p-overlayPanel>
      </li>
      <li *ngIf="user.hasRole[Roles.OrgAdmin] || user.hasRole[Roles.CSRAdmin] || user.hasRole[Roles.CyberPlanAdmin]" class="p-col-12 p-md-4 p-lg-2 ol-module">
        <button type="text"  (click)="solMgr.toggle($event)"  routerLinkActive="active"
                pTooltip="Setup &amp; configure your organization."
                tooltipPosition="top">
          <i class="fa fa-cogs icon-info"></i>
          <h3 class="grid-head">Settings &amp; Solutions</h3>
          <i class="fa fa-2x fa-caret-down"></i>
        </button>
        <p-overlayPanel #solMgr styleClass="menu-single menusolmgr">
          <h6>Settings &amp; Solutions</h6>
          <ul class="main-connect p-grid">
            <li class="p-col-12">
              <a [routerLink]="RouteLink.SolMgrMain" routerLinkActive="active">Solution Manager</a>
            </li>
            <li class="p-col-12">
              <a [routerLink]="[RouteLink.SolMgrOrgSetupValidation]" routerLinkActive="active">Setup Validations</a>
            </li>
            <li class="p-col-12">
              <a [routerLink]="[RouteLink.SolMgrTransactionValidation]" routerLinkActive="active">Transaction Validations</a>
            </li>
            <li class="p-col-12">
              <a [routerLink]="[RouteLink.SolMgrDataImport]" routerLinkActive="active">Data Import</a>
            </li>
            <li>
          </ul>
        </p-overlayPanel>
      </li>
      <!-- <app-connect></app-connect>   -->


      <div class="p-col-12"></div>
      <!-- ACase: hid these placeholder graphics until we have embedded qlik items
      <li class="p-col-12 p-md-6 p-lg-4">
        <h4>Recruit2Hire</h4>
        <div id="home-chart-first" class="home-chart">
          <img src="assets/img/donut.png" alt="alternative text">
        </div>



        <h5 class="subtitle">200 open positions to be filled.</h5>

      </li>
      <li class="p-col-12 p-md-6 p-lg-4">
        <h4>Invoices &amp; Payments</h4>
        <div id="home-chart-second" class="home-chart">
          <img style="border:1px solid #efefef;" src="assets/img/area.png" alt="alternative text">
        </div>

        <h5 class="subtitle">Invoices sent and payments received.</h5>
      </li>
      <li class="p-col-12 p-md-12 p-lg-4">
        <h4>Revenue By State</h4>
        <div id="home-chart-third" class="home-chart">
          <img src="assets/img/grid.png" alt="alternative text">
        </div>

        <h5 class="subtitle">Breakdown of revenue by state.</h5>
      </li>
      -->
    </ul>
  </section>


</main>
<section class="mainhome-fourthrow ui-g">
  <!-- <article class="p-col-12">
    <h1 style="color: #fff;">Join the Marketplace</h1>
    <p class="margin-bottom">
      Thousands of top trusted vendors ready to bring you solutions.
      <a class="button s-12 l-4 center" href="product.html" style="margin-left: 20px !important; display: inline !important;">Learn more
      </a>
    </p>

  </article> -->
  <article class="p-col-12">
    <h1 style="color: #fff;">You've grown. Your systems need to grow too.</h1>
    <p class="margin-bottom">
      Has your business grown? Great. We have a solution for you.
      <a class="button s-12 l-4 center" href="http://www.atworksys.com" target="new" style="margin-left: 10px !important; display: inline !important;">Learn more
      </a>
    </p>

  </article>
</section>

<div *ngIf="showQlikComponent">
  <!-- <app-qlik-test></app-qlik-test> -->

</div>
<style>
  body {
    background-image: none !important;
  }
</style>
